<template>
  <div v-if="payrateChanges">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <div class="vx-row">
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="HomeIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ payrateChanges.length }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">All payrate changes</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numLevelChangePayrates }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Level change payrates</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numConsolidatedPayrates }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Consolidated payrates</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numSalaryIncreasePayrates }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Rekom salary increase</p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="row">
      <vs-button class="btn btn-primary" @click="exportToExcel"> Export to Excel </vs-button>
      <vs-table max-items="100" pagination search :data="payrateChangesWithTextReason">
        <template slot="thead">
          <vs-th sort-key="displayName"> Name & campus level</vs-th>
          <vs-th sort-key="fromPayrate"> Payrate before </vs-th>
          <vs-th sort-key="toPayrate"> Payrate after </vs-th>
          <vs-th sort-key="payrateGroupName"> Payrate name </vs-th>
          <vs-th sort-key="textReason"> Reason </vs-th>
          <vs-th sort-key="timestamp"> Update at </vs-th>
          <vs-th sort-key="validFrom"> Valid from </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="lc.id" v-for="lc in data">
            <vs-td :data="lc.displayName">
              {{ `${lc.displayName} (${lc.userLevel})` }}
            </vs-td>

            <vs-td :data="lc.fromPayrate">
              {{ lc.fromPayrate }}
            </vs-td>

            <vs-td :data="lc.toPayrate">
              {{ lc.toPayrate }}
            </vs-td>

            <vs-td :data="lc.payrateGroupName">
              {{ lc.payrateGroupName }}
            </vs-td>

            <vs-td :data="campusLevelChangeReasonEnum[lc.reason]">
              {{ lc.textReason }}
            </vs-td>

            <vs-td :data="lc.timestamp">
              {{ moment(lc.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
            </vs-td>
            <vs-td :data="lc.validFrom">
              {{ moment(lc.validFrom).format("YYYY-MM-DD HH:mm:ss") }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      moment,
      campusLevelChangeReasonEnum: {
        1: "Level changed",
        2: "Consolidated payrate",
        3: "Rekom salary increase",
      },
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      payrateChanges: "payrates/plandayPayrateChanges",
      numConsolidatedPayrates: "payrates/numConsolidatedPayrates",
      numLevelChangePayrates: "payrates/numLevelChangePayrates",
      numSalaryIncreasePayrates: "payrates/numSalaryIncreasePayrates",
    }),

    payrateChangesWithTextReason() {
      return this.payrateChanges.map(e => ({
        ...e,
        textReason: this.campusLevelChangeReasonEnum[e.reason],
      }));
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("payrates/getPayratePlandayChanges");
    this.$vs.loading.close();
  },
  methods: {
    async exportToExcel() {
      console.log("Downloading export");
      this.$vs.loading();
      await this.$store.dispatch("payrates/exportPayrateChanges");
      this.$vs.loading.close();
    },
  },
};
</script>

<style lang="scss">
</style>
